var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7575 5.37216L6.75746 6.87216C6.3123 6.98345 6 7.38343 6 7.8423V20.5H14V10.5V8.49997V6.3423C14 5.69173 13.3886 5.21437 12.7575 5.37216ZM16 10.5V20.5H18V11.5C18 10.9477 17.5523 10.5 17 10.5H16ZM20 22.5H21C21.5523 22.5 22 22.0523 22 21.5C22 20.9477 21.5523 20.5 21 20.5H20V11.5C20 9.84312 18.6569 8.49997 17 8.49997H16V6.3423C16 4.39059 14.1658 2.95851 12.2724 3.43187L6.27239 4.93187C4.93689 5.26575 4 6.4657 4 7.8423V20.5H3C2.44772 20.5 2 20.9477 2 21.5C2 22.0523 2.44772 22.5 3 22.5H4H6H14H16H18H20Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17.5C8 16.9477 8.44772 16.5 9 16.5H11C11.5523 16.5 12 16.9477 12 17.5C12 18.0523 11.5523 18.5 11 18.5H9C8.44772 18.5 8 18.0523 8 17.5Z",
    fill: "#6F767E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.5C8 12.9477 8.44772 12.5 9 12.5H11C11.5523 12.5 12 12.9477 12 13.5C12 14.0523 11.5523 14.5 11 14.5H9C8.44772 14.5 8 14.0523 8 13.5Z",
    fill: "#6F767E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.5C8 8.94772 8.44772 8.5 9 8.5H11C11.5523 8.5 12 8.94772 12 9.5C12 10.0523 11.5523 10.5 11 10.5H9C8.44772 10.5 8 10.0523 8 9.5Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.cd44b3079e6461c5d52640bd8fe38ddb.svg";
export { ForwardRef as ReactComponent };